// extracted by mini-css-extract-plugin
export var anchor = "_46-0";
export var discard = "_46-4";
export var muiTooltipTooltip = "_46-6";
export var notificationBar = "_46-3";
export var saveButtonHoverSlotWrapper = "_46-5";
export var show = "_46-2";
export var spacer = "_46-1";